import styled from '@emotion/styled'
import * as React from 'react'

import { formatPhoneNumber } from '~logic/helpers/formatPhoneNumber'

type TProps = NoChildren & {
  phone: string
}

const StyledPhoneLink = styled.a`
  color: inherit;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`

/**
 * Wraps phone numbers to make them into a clickable links.
 */
export const PhoneLink: React.FC<TProps> = ({ phone }) => {
  return <StyledPhoneLink href={`tel:${phone}`}>{formatPhoneNumber(phone)}</StyledPhoneLink>
}
